export const modalScale = 1.1954;
export const resourceNames = ['ore', 'fish', 'corn', 'wood', 'hides'];
export const toolTypes = ['axe', 'crossbow', 'pickaxe', 'rod', 'sickle', 'sword'];
export const toolTiers = ['adamantite', 'crystal', 'infernium', 'steel', 'stone'];
export const marketFilters = ['all', 'mining', 'fishing', 'hunting', 'logging', 'farming', 'fighting'];